import { faChevronLeft } from '@fortawesome/pro-light-svg-icons'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IActivityCategories } from '../../../../../../Activity/interface/IActivityCategories'
import { Spinner } from '../../../../../../App/Components'
import TextInput from '../../../../../../App/Components/Form/TextInput/TextInput'
import { useAppDispatch } from '../../../../../../App/Hooks/reduxHooks'
import { updateSurveyTrigger } from '../../../../Store/Action'
import { DescriptionCardState } from '../EditDescriptionCard'

import {
  ActivityModalBackButton,
  ActivityModalBackButtonIcon,
  ActivityModalBackButtonText,
  ActivityModalHeader,
  ActivityModalList,
  ActivityModalListItem,
  ActivityModalListItemGraphic,
  ActivityModalListItemImage,
  ActivityModalListItemLabel,
  ActivityModalWrapper,
  Backdrop,
  NoActivityText,
} from './style'

type Props = {
  activityCategories: IActivityCategories[] | undefined
  surveyId: string
  setDescriptionCardState: (arg: DescriptionCardState) => void
  descriptionCardState: DescriptionCardState
  setModalState: (arg: null) => void
}

export const EditDescriptionCategoryModal: React.FC<Props> = ({
  activityCategories,
  setDescriptionCardState,
  descriptionCardState,
  setModalState,
  surveyId,
}) => {
  const [filteredSearchResults, setFilteredSearchResults] = useState<
    IActivityCategories[] | undefined
  >(undefined)

  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const searchItems = (searchValue: string) => {
    if (!activityCategories) {
      return
    }

    if (searchValue === '') {
      setFilteredSearchResults(undefined)
      return
    }

    const searchResults = activityCategories.filter(activity => {
      return activity.name.toLowerCase().includes(searchValue.toLowerCase())
    })

    setFilteredSearchResults(searchResults)
  }

  const updateCategoryArray = (categoryId: number) => {
    const trigger = descriptionCardState.trigger
    if (!trigger || trigger.type !== 'send_after_appointment') {
      return
    }

    const oldIds = trigger.categoryIds ?? []
    const newCategoryIds = [...oldIds, categoryId]

    setDescriptionCardState({
      ...descriptionCardState,
      currentState: 'loading',
    })

    dispatch(
      updateSurveyTrigger(surveyId, {
        ...trigger,
        categoryIds: newCategoryIds,
      }),
    ).then(() =>
      setDescriptionCardState({
        ...descriptionCardState,
        currentState: 'idle',
        trigger: {
          ...trigger,
          categoryIds: newCategoryIds,
        },
      }),
    )
  }

  return (
    <>
      <ActivityModalWrapper>
        <ActivityModalHeader>{t('Add category')}</ActivityModalHeader>
        <TextInput
          type="text"
          onChange={e => searchItems(e.target.value)}
          defaultText={t('Search category')}
        />
        <ActivityModalBackButton onClick={() => setModalState(null)}>
          <ActivityModalBackButtonIcon icon={faChevronLeft} />
          <ActivityModalBackButtonText>{t('Back')}</ActivityModalBackButtonText>
        </ActivityModalBackButton>
        {filteredSearchResults && (
          <ActivityModalList>
            {filteredSearchResults.map(foundCategory => (
              <>
                <ActivityModalListItem
                  onClick={() => {
                    updateCategoryArray(foundCategory.id)
                    setModalState(null)
                  }}
                  key={`search${foundCategory.id}`}>
                  {foundCategory.image === null ? (
                    <ActivityModalListItemGraphic color={'#2164db'} />
                  ) : (
                    <ActivityModalListItemImage
                      alt="image"
                      src={`${foundCategory.image}&w=60&h=60&fit=crop`}
                    />
                  )}
                  <ActivityModalListItemLabel>
                    {activityCategories &&
                      activityCategories.find(
                        oneCat => oneCat.id === foundCategory.id,
                      )?.name}{' '}
                    &raquo;&nbsp;
                    {foundCategory.name}
                  </ActivityModalListItemLabel>
                </ActivityModalListItem>
              </>
            ))}
          </ActivityModalList>
        )}

        {!filteredSearchResults &&
          typeof filteredSearchResults === undefined && (
            <NoActivityText> {t('No categories')}</NoActivityText>
          )}
        <ActivityModalList>
          {!activityCategories ? (
            <Spinner />
          ) : (
            <>
              {typeof filteredSearchResults === 'undefined' &&
                activityCategories.map(activities => (
                  <ActivityModalListItem
                    key={activities.id}
                    onClick={() => {
                      updateCategoryArray(activities.id)
                      setModalState(null)
                    }}>
                    {activities.image === null ? (
                      <ActivityModalListItemGraphic color={'#2164db'} />
                    ) : (
                      <ActivityModalListItemImage
                        alt="image"
                        src={`${activities.image}&w=60&h=60&fit=crop`}
                      />
                    )}

                    <ActivityModalListItemLabel>
                      {activities.name}
                    </ActivityModalListItemLabel>
                  </ActivityModalListItem>
                ))}
            </>
          )}
        </ActivityModalList>
      </ActivityModalWrapper>
      <Backdrop onClick={() => setModalState(null)} />
    </>
  )
}
